// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";

// components
import BaseComponent from "@cloudspire/legacy-resources/src/components/BaseComponent";
import Image from "@cloudspire/legacy-resources/src/components/Image";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

type PropsType = {
  splashSource: { uri: string };
};

const styles = StyleSheet.create({
  splash: {
    flexDirection: "row",
    justifyContent: "center",
  },
  container: {
    maxWidth: emToPx(43.75),
    width: "100%",
  },
});

const Splash: React.FunctionComponent<PropsType> = (props) => {
  const { splashSource } = props;

  return (
    <BaseComponent>
      <View style={styles.splash}>
        <View style={styles.container}>
          <Image ratio={590 / 1180} source={splashSource} />
        </View>
      </View>
    </BaseComponent>
  );
};

export default Splash;
